import assert from 'assert';
import React, {useMemo} from 'react';

import {makeReactContext} from 'lib/makeReactContext';
import {TableModelContext} from 'notebook/tables/store/contexts/TableModelContext';
import {createRowModelSelector, RowModel} from 'notebook/tables/store/models/RowModel';
import {createTableEditableStore, TableEditableStore} from 'notebook/tables/store/TableStore';

interface RowContextInterface {
  useTableEditableStore: ReturnType<typeof createTableEditableStore>;
  rowIndex: number;
  rowModelSelector: (state: TableEditableStore) => RowModel;
}

export const RowModelContext = makeReactContext<RowContextInterface>(() => {
  assert(false, 'TableRowContext must be used within a RowStateWrapper');
}, 'StructuredTableContext');

export function RowModelProvider({
  rowIndex,
  children,
}: {
  rowIndex: number;
  children: React.ReactNode;
}): JSX.Element {
  const {tableModelSelector, useTableEditableStore} = TableModelContext.useContext();
  const rowModelSelector = useMemo(
    () => createRowModelSelector(tableModelSelector, rowIndex),
    [tableModelSelector, rowIndex]
  );
  const contextValue = useMemo(
    () => ({rowIndex, rowModelSelector, useTableEditableStore}),
    [rowIndex, rowModelSelector, useTableEditableStore]
  );

  return <RowModelContext.Provider value={contextValue}>{children}</RowModelContext.Provider>;
}
